<!-- Main Content Card -->
<div class="content-card">
  <div class="card-header">
    <h3 class="card-title">
      <svg>
        <use href="assets/icons.svg#document"></use>
      </svg>
      Sign agreement
    </h3>
  </div>
  <div class="card-intro">
    <svg>
      <use href="assets/icons.svg#document"></use>
    </svg>
    <p>Review contract details and capture customer signature</p>
  </div>
  <div class="card-content">
    <!-- Contract Section -->
    <div class="contract-section">
      <h4 class="section-title">Service Agreement</h4>
      <div class="contract-viewer">
        <textarea class="contract-text" readonly>{{ contractText }}</textarea>
      </div>
    </div>

    <!-- Signature Section -->
    <div class="signature-section">
      <h4 class="signature-title">
        <svg>
          <use href="assets/icons.svg#pen"></use>
        </svg>
        Customer Signature
      </h4>
      <canvas #signatureCanvas class="signature-canvas"></canvas>
      <div class="action-buttons">
        <button class="btn clear-btn" type="button" (click)="clearSignature()">
          <svg>
            <use href="assets/icons.svg#undo"></use>
          </svg>
          Clear
        </button>
        @if (hasSignature) {
          <p class="signature-captured">
            <svg>
              <use href="assets/icons.svg#check"></use>
            </svg>
            Signature Captured
          </p>
        }
      </div>
      <!-- Agreement Terms -->
      <div class="agreement-terms">
        <ul>
          <li>Customer confirms agreement to all terms and conditions</li>
          <li>Digital signature has the same legal validity as handwritten</li>
          <li>Contract copy will be sent to customer's email</li>
        </ul>
      </div>
    </div>
    <!-- Action Buttons -->
    <div class="action-buttons">
      <button class="btn btn-secondary" type="button" (click)="goBack()">Back</button>
      <button
        class="btn btn-primary"
        type="button"
        [disabled]="!hasSignature"
        (click)="submitOrder()"
      >
        Submit Order
      </button>
    </div>
  </div>
</div>
